<video
  class="course-hero__primary-image"
  [poster]="posterUrl()"
  [src]="videoUrl()"
  controls
  (ended)="onVideoEnded()"
></video>
